import { store } from '@/app/store'
import { adminApi } from '@/data/admin/api/admin_api'
import type { UpdateAdminProfilePayload } from '@/domain/profile/entities/admin_profile.entity'
import { mapAdminProfileDto } from '../mappers/profile.mapper'

export class ProfileRtkDatasource {
  async getMe() {
    const result = await store.dispatch(adminApi.endpoints.getAdminMe.initiate())
    if (result.error) {
      throw result.error
    }
    if (!result.data) {
      throw new Error('Admin profile not found')
    }
    return mapAdminProfileDto(result.data)
  }

  async updateMe(payload: UpdateAdminProfilePayload) {
    const result = await store.dispatch(
      adminApi.endpoints.updateAdminMe.initiate({ name: payload.name })
    )
    if (result.error) {
      throw result.error
    }
    if (!result.data) {
      throw new Error('Failed to update admin profile')
    }
    return mapAdminProfileDto(result.data)
  }
}
